import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation, useParams } from 'react-router-dom';
import ReactSelect from "react-select";
import ReactToPrint from 'react-to-print';
import { useRecoilState, } from 'recoil';
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import { popupCustomerFlowAtom, popupTransactionHistoryAtom } from '../../state';
import { transactionHistoryColTable } from "../../utils/col-table";

const TransactionHistoryBankAccountManager = () => {
  const clearPagi = useRef();
  const history = useHistory();
  const printRef = useRef();

  const [data, setData] = useState([]);
  const { bankAccountId } = useParams();

  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [onSearchText, setSearchText] = useState("");
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [bankAccountInfo, setBankAccountInfo] = useState({});

  const [popupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);

  const [filter, setFilter] = useState({
    categoryId: '',
    customerId: ''
  });

  const initRangeDate = () => {
    const params = new URLSearchParams(location.search);
    const startParam = params.get('start');
    const endParam = params.get('end');
    return {
      start: startParam ? new Date(startParam) : moment().startOf('months').toDate(),
      end: endParam ? new Date(endParam) : moment().toDate(),
    };
  };

  const [rangeDate, setRangeDate] = useState(initRangeDate);
  const [updatedAt, setUpdatedAt] = useState();

  const colTable = transactionHistoryColTable();

  useEffect(() => {
    GET("/category", {}, true).then(({ data }) => {
      setCategoryOptions([
        ...data?.map((c) => ({
          label: `${c.name}${c.type === 'IN' ? '(Nhập)' : '(Xuất)'}`,
          value: c.id,
        })),
      ]);
    });

    GET("/customer", {}, true).then(({ data }) => {
      setCustomerOptions([
        ...data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        })),
      ]);
    });

    GET(`/bank-account/${bankAccountId}`, {}, true)
      .then(({ data }) => setBankAccountInfo(data))
  }, []);


  useEffect(() => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        bankAccountId,
        ...(filter.customerId ? { customerId: filter.customerId } : {}),
        ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
        start: moment(rangeDate.start).format('YYYY-MM-DD'),
        end: moment(rangeDate.end).format('YYYY-MM-DD'),
      };
      if (onSearchText !== "") {
        params.search = onSearchText;
      }

      GET(`transaction-history`, params, true)
        .then(({ data }) => {
          setData([...data?.rows]);
          setSummary({
            ...data.summary,
            count: data.count,
          });

        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [onSearchText, filter, updatedAt, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt]);

  // toggle function to view order details


  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };


  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  const exportExcel = () => {
    const params = new URLSearchParams({
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
      ...(filter.categoryId ? { categoryId: filter.categoryId } : {}),
      ...(onSearchText !== '' ? { search: onSearchText } : {}),
      bankAccountId,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/transaction-history/report-by-find-by-bank-account-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          dateFormat={'dd/MM/yy'}
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>

                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm KH/NCC"
                          classNamePrefix="form-control"
                          options={customerOptions}
                          value={customerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Tìm kiếm danh mục"
                          options={categoryOptions}
                          value={categoryOptions.find(
                            (c) => c.value === filter.categoryId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              categoryId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          placeholder="Tìm kiếm giao dịch"
                          className="form-control  border-primary"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button className={'btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3 btn-secondary">
                          Xuất excel
                        </Button>
                        <Button
                          className="ml-3 btn-secondary"
                          onClick={() => {
                            history.goBack();
                          }}
                        >
                          <span>Trở về</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                          {/* <label>
                            <span className="d-none d-sm-inline-block">Show</span>
                            <Input type="month" />
                          </label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">Sổ Quỹ (Tài khoản(đ): {bankAccountInfo?.name} <NumericFormat
                    displayType={"text"}
                    value={bankAccountInfo?.amount || 0}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    className="h4"
                  />)</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h6>

                  <Table
                    notShowPagi={true}
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={<>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Số dư đầu kỳ
                        </td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.firstAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.firstAmountUSD || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>

                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Tổng phát sinh
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountIn || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountOut || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />

                        </td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountInUSD || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountOutUSD || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.totalAmountUSD || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />

                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td></td>
                        <td></td>
                        <td colSpan={2}>
                          Số dư cuối kỳ
                        </td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.lastAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary?.lastAmountUSD || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </td>
                        <td></td>
                        <td></td>

                      </tr>
                    </>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default TransactionHistoryBankAccountManager;
